import { Icon } from '@oneaudi/unified-web-components';
import React from 'react';
import styled from 'styled-components';

const IconDiv = styled.div<{ color?: string }>`
  svg {
    color: ${({ color }) => color ?? '#009900'};
  }
`;

interface CheckIconProps {
  color?: string;
  stroke?: string;
  className?: string;
}

const Check: React.FC<CheckIconProps> = ({ color, className }) => (
  <IconDiv color={color}>
    <Icon className={className} name="select" size="s" />
  </IconDiv>
);

export default Check;
